module.exports = __webpack_public_path__ + "img/user-journey.eecb95b4.svg";